import { render, staticRenderFns } from "./PayloadFormatter.vue?vue&type=template&id=c6fa36a6"
import script from "./PayloadFormatter.vue?vue&type=script&lang=js"
export * from "./PayloadFormatter.vue?vue&type=script&lang=js"
import style0 from "./PayloadFormatter.vue?vue&type=style&index=0&id=c6fa36a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports